import moment from 'moment';
import { Link } from 'react-router-dom';

import { TEntityGridColumn } from 'app/common/entity-grid/core';
import { StringFilterDataGrid } from 'app/common/ui/data-grid/filters';
import { appRoute } from 'app/railways/router/routes';

import { TTariffProfile } from '../../../core/tariff-profile';

const dateCellRender = (date?: string | null) => {
  const formattedDate = date ? moment(date).format('HH:mm DD.MM.YYYY') : '-';

  return formattedDate;
};

export const cols: TEntityGridColumn<TTariffProfile>[] = [
  {
    field: 'id',
    headerName: 'ID',
    minWidth: 50,
    headerCheckboxSelection: false,
    checkboxSelection: false,
    sortable: true,
    comparator: () => 0,
    cellRenderer: ({ data }: { data: TTariffProfile }) => {
      const path = appRoute.TARIFF_PROFILES.DETAILS.buildPath({
        tariffProfileId: data.id,
      });

      return <Link to={path}>{data.id}</Link>;
    },
  },
  {
    field: 'name',
    headerName: 'Название',
    sortable: false,
    colId: 'nameRu',
    filter: StringFilterDataGrid({ filterName: 'name' }),
    comparator: () => 0,
  },
  {
    field: 'fromPayDate',
    headerName: 'От даты платежа',
    sortable: false,
    colId: 'fromPayDate',
    cellRenderer: ({ data }: { data: TTariffProfile }) => {
      return dateCellRender(data.fromPayDate);
    },
    comparator: () => 0,
  },
  {
    field: 'toPayDate',
    headerName: 'По дату платежа',
    sortable: false,
    colId: 'toPayDate',
    comparator: () => 0,
    cellRenderer: ({ data }: { data: TTariffProfile }) => {
      return dateCellRender(data.toPayDate);
    },
  },
  {
    field: 'fromTripDate',
    headerName: 'От даты начала рейса',
    sortable: false,
    colId: 'fromTripDate',
    comparator: () => 0,
    cellRenderer: ({ data }: { data: TTariffProfile }) => {
      return dateCellRender(data.fromTripDate);
    },
  },
  {
    field: 'toTripDate',
    headerName: 'По дату начала рейса',
    sortable: false,
    colId: 'toTripDate',
    comparator: () => 0,
    cellRenderer: ({ data }: { data: TTariffProfile }) => {
      return dateCellRender(data.toTripDate);
    },
  },
  {
    field: 'name',
    headerName: '',
    minWidth: 50,
    sortable: false,
    comparator: () => 0,
    cellRenderer: ({ data }: { data: TTariffProfile }) => {
      const path = appRoute.TARIFF_PROFILES.DETAILS.buildPath({
        tariffProfileId: data.id,
      });

      return <Link to={path}>Подробнее</Link>;
    },
  },
];
